import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-scroll';
import classNames from 'classnames';

import { HEADER_HEIGHT, ANIMATION_SETTINGS } from 'config';

import {
  scrollButtonsContainer,
  scrollButton,
  scrollButtonActive,
} from './scss/ScrollButtons.module.scss';

const ScrollButtons = ({ sections }) => {
  const buttonProps = {
    spy: true,
    offset: -HEADER_HEIGHT,
    duration: ANIMATION_SETTINGS.ANIMATION_DURATION.NORMAL,
    smooth: 'easeInOutCubic',
  };
  return (
    <div className={classNames('d-none', 'd-md-block', scrollButtonsContainer)}>
      {sections.map(section => (
        <Link
          key={section}
          to={section}
          value={section}
          activeClass={scrollButtonActive}
          className={scrollButton}
          {...buttonProps}
        />
      ))}
    </div>
  );
};

ScrollButtons.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ScrollButtons;
